import * as tslib_1 from "tslib";
import { BUSINESS_CONST } from '../../constants/business.constants';
import { OfferModel } from '../../models/offer.model';
import { ParametersService } from '../parameters/parameters.service';
import { RequestService } from '../request/request-onboarding.service';
import * as i0 from "@angular/core";
import * as i1 from "../parameters/parameters.service";
import * as i2 from "../request/request-onboarding.service";
/**
 * Servicio para los servicios de aprobados en firme
 * ofrecido por el banco.
 * @Injectable
 */
var FirmlyApprovedService = /** @class */ (function () {
    /**
     * Constructor del servicio de Aprobados en Firme y Pre-Aprobados.
     * @param parametersService
     * @param abreCuentasService
     */
    function FirmlyApprovedService(parametersService, requestService) {
        this.parametersService = parametersService;
        this.requestService = requestService;
        /**
         * Datos de la oferta que se recibe desde el chasis del canal
         * y corresponde a las ofertas de Aprobados en Firme.
         */
        this.offer_channel = {
            offerType: '',
            offerId: '',
        };
        /**
         * Datos detallados dela TC del Aprobado En Firme
         * conforme lo selecciona el usuario en la etapa de
         * Configuración del producto
         */
        this.detailProductsMulti = [];
        /**
         * Indicador si el flujo va por Mono (1 solo producto) o
         * Multi (2 o más productos)
         */
        this.multiproducto_Signal = false;
    }
    /**
     * Función que permite modificar la señal de flujo Multiproducto
     * @param {boolean} status - Estado a ingresar
     */
    FirmlyApprovedService.prototype.setMultiproducto_Signal = function (status) {
        this.multiproducto_Signal = status;
    };
    /**
     * Función quer permite obtener la señal si el flujo
     * es Multiproducto o Monoproducto
     * @returns {boolean} - Señal flujo Multi
     */
    FirmlyApprovedService.prototype.getMultiproducto_Signal = function () {
        return this.multiproducto_Signal;
    };
    /**
     * Función que edita el valor del offerId recibido desde el
     * chasis del canal.
     * @param {String} offerId - Id de la oferta a consultar.
     */
    FirmlyApprovedService.prototype.setOffer_Channel = function (offerDataChannel) {
        this.offer_channel = offerDataChannel;
    };
    /**
     * Función que devuelve el valor del OfferId.
     * @returns {String} - Valor del Id de las ofertas a consultar.
     */
    FirmlyApprovedService.prototype.getOfferId_Channel = function () {
        return this.offer_channel.offerId;
    };
    /**
     * Función que devuelve el valor del OfferId.
     * @returns {String} - Tipo de las ofertas a consultar.
     */
    FirmlyApprovedService.prototype.getOfferType_Channel = function () {
        return this.offer_channel.offerType;
    };
    /**
     * Función que permite ir añadiendo los productos individualmente al array
     * de productos de Aprobados en Firme
     * @param {IFirmlyApproved} offer - Oferta de Aprobado en Firme
     */
    FirmlyApprovedService.prototype.addOffer = function (offer) {
        offer.product_type = this.getSelectProductFirmlyApproved(offer.product);
        this.productsFirmlyApproved.push(offer);
    };
    /**
     * Función que permite almacenar los datos que llegan desde vitrinas
     * y transversal al flujo de Aprobados en Firme y Pre-Aprobados.
     * @param {IFirmlyApproved} product - Datos obtenidos de la vitrina
     */
    FirmlyApprovedService.prototype.setProductsFirmlyApproved = function (products) {
        this.productsFirmlyApproved = products;
    };
    /**
     * Función que permite enviar todo el objeto completo de FirmlyApproved
     * @returns {IFirmlyApproved} - Devuelve el objeto completo
     */
    FirmlyApprovedService.prototype.getProductsFirmlyApproved = function () {
        return this.productsFirmlyApproved;
    };
    /**
     * Función que permite llenar los datos de los productos del Aprobado
     * En Firme y que reemplaza validaciones de PCO
     * @param {string} product_type - Producto a ingresar información
     */
    FirmlyApprovedService.prototype.setDetailProductsMulti = function (product_type, cant_TCR) {
        product_type = this.getSelectProductFirmlyApproved(product_type);
        var product_selected = this.getProduct_FirmlyApproved(product_type);
        var detail_exist = this.detailProductsMulti === undefined ? null : this.detailProductsMulti.find(function (element) { return element.product_type === product_type; });
        if (!product_selected || detail_exist) {
            return;
        }
        var cant_ingreso = cant_TCR || 1;
        for (var index = 0; index < cant_ingreso; index++) {
            var product = {
                brand: '',
                product_type: product_type,
                limit_amount: {
                    currency: 'COP',
                    amount: parseInt(product_selected.amount, 10),
                    decimals: 0,
                },
                term: product_selected.maxTermFreeInvestment,
            };
            this.detailProductsMulti.push(product);
        }
    };
    /**
     * Función que permite eliminar un producto del conjunto
     * de productos seleccionados por el cliente.
     * @param {string} product_type - Tipo del producto a eliminar
     */
    FirmlyApprovedService.prototype.delete_DetailProductMulti = function (product_type) {
        this.detailProductsMulti = this.detailProductsMulti.filter(function (product) { return product.product_type !== product_type; });
        console.log('Nuevo array de Productos Multi Aprobados Firme: ', this.detailProductsMulti);
    };
    /**
     * Función que devuelve los detalles de la TC y que se reemplaza
     * por algunos modelos de PCO del Onboarding normal.
     * @param {string} product_type - producto a obtener información
     * @returns {any} - Detalles de la TC
     */
    FirmlyApprovedService.prototype.getDetailProductsMulti = function (product_type) {
        console.log('Producto a buscar: ', product_type, '\nDetalles encontrados: ', this.detailProductsMulti);
        if (!product_type) {
            return this.detailProductsMulti;
        }
        return this.detailProductsMulti.filter(function (element) { return element.product_type === product_type; });
    };
    /**
     * Función que permite setear la selección del tipo de TC seleccionado por
     * el usuario y que es de Aprobados En Firme el producto
     * @param {number} position - Posición del brand seleccionado
     * @returns {string} - Nombre del Brand de la TC
     */
    FirmlyApprovedService.prototype.selectedBrand = function (position) {
        var brand = {
            1: function () { return BUSINESS_CONST.MASTERCARD; },
            2: function () { return BUSINESS_CONST.VISA; },
            3: function () { return BUSINESS_CONST.VISALM; },
            default: function () { return ''; },
        };
        return brand[position] ? brand[position]() : brand.default();
    };
    /**
     * Función que permite validar si el cliente optó por el producto especial ofrecido por el banco.
     * @returns {boolean} - False - Tiene 1 o más productos de Aprobados en Firme, True - No cuenta con el producto especial.
     */
    FirmlyApprovedService.prototype.isEmpty = function () {
        return this.productsFirmlyApproved === undefined ||
            this.productsFirmlyApproved.length === 0
            ? true
            : false;
    };
    /**
     * Función que devuelve el producto correspondiente al aprobado en firme
     * @returns {string} - Nombre del producto correspondiente al aprobado en firme.
     */
    FirmlyApprovedService.prototype.getSelectProductFirmlyApproved = function (product) {
        console.log('product ->', product);
        var productApproved = {
            ORD: function () { return 'freeInvestment'; },
            TCR: function () { return 'creditCard'; },
            CRP: function () { return 'revolvingCredit'; },
            MULTI: function () { return 'multi'; },
            default: function () { return product; },
        };
        return productApproved[product]
            ? productApproved[product]()
            : productApproved.default();
    };
    /**
     * Función que permite obtener un producto en específico de los listados
     * en el Aprobado en Firme.
     * @param {string} product - Tipo del producto a buscar (ORD, TCR, CRP)
     * @returns - Producto encontrado.
     */
    FirmlyApprovedService.prototype.getProduct_FirmlyApproved = function (product) {
        product = this.getSelectProductFirmlyApproved(product);
        return this.productsFirmlyApproved.find(function (element) { return (element.product_type === product); });
    };
    /**
     * Función que permite cargar las ofertas de Aprobado En Firme Multiproducto para el cliente
     * @param {String} offer_id - Id de la oferta que se cargó en el home de los canales.
     */
    FirmlyApprovedService.prototype.getProductsOffer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestService
                            .getOffersFromServer(this.offer_channel.offerId || undefined)
                            .then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(res.data && res.data.length > 0)) return [3 /*break*/, 2];
                                        this.productsFirmlyApproved = [];
                                        return [4 /*yield*/, res.data.map(function (offer) {
                                                if (offer.offer_status == '0') {
                                                    _this.addOffer(new OfferModel(offer));
                                                }
                                            })];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })
                            .catch(function (err) {
                            console.warn('El cliente no cuenta con ofertas de aprobados en firme ->', err);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función que permite actualizar el estado de una Oferta y sus productos.
     * @param {number} status_id - Estado para actualizar la oferta de la vitrina
     * @param {[any]} product_list - Ofertas a modificar
     */
    FirmlyApprovedService.prototype.turnOffOffer = function (status_id, product_list) {
        var _this = this;
        var offer_list = [this.offer_channel];
        this.requestService
            .updateOffer(status_id, offer_list, product_list)
            .then(function (res) {
            _this.productsFirmlyApproved = [];
            console.log('Datos de Aprobados Firme >>>>> \n', res);
        });
    };
    /**
     * Función que valida y retorna las solicitudes de un cliente que se encuetran en zona gris (cumplimiento o credito)
     * @returns {[Object]} - Array de solicitudes
     */
    FirmlyApprovedService.prototype.validateRequestsGZ = function (documentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resObject, creditGrayZone, complianceGrayZone, productCodesValidateGZ, oneMonthAgo;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resObject = {};
                        creditGrayZone = this.parametersService.getBusinessRule('states_gray_zone').credit_gray_zone;
                        complianceGrayZone = this.parametersService.getBusinessRule('states_gray_zone').compliance_gray_zone;
                        productCodesValidateGZ = this.parametersService.getBusinessRule('product_codes_validate_gz_af');
                        oneMonthAgo = new Date();
                        if (oneMonthAgo.getMonth() === 0) {
                            oneMonthAgo.setFullYear(oneMonthAgo.getFullYear() - 1);
                            oneMonthAgo.setMonth(11);
                        }
                        else {
                            oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
                        }
                        // Consulta al canal de las solicitudes de un cliente por numero de identificacion.
                        return [4 /*yield*/, this.requestService
                                .getChannelNotificationClient(documentId)
                                .then(function (res) {
                                var dataResponse = res.data;
                                var visibleSolicitations = [];
                                dataResponse.forEach(function (solicitation) {
                                    var stateSolicitation = solicitation.solicitation_phase +
                                        '-' +
                                        solicitation.solicitation_status;
                                    var isInCreditGrayZone = creditGrayZone.includes(stateSolicitation);
                                    var isInComplianceGrayZone = complianceGrayZone.includes(stateSolicitation);
                                    var dateRequest = new Date(solicitation.last_update_date);
                                    if ((isInCreditGrayZone || isInComplianceGrayZone) &&
                                        dateRequest >= oneMonthAgo &&
                                        solicitation.products.some(function (product) {
                                            return productCodesValidateGZ.indexOf(product.product_type) >= 0;
                                        })) {
                                        visibleSolicitations.push(solicitation);
                                    }
                                });
                                resObject.code = '200';
                                resObject.data = visibleSolicitations;
                            })
                                .catch(function (error) {
                                console.error(error);
                                resObject.code = '107';
                                resObject.data = [{}];
                            })];
                    case 1:
                        // Consulta al canal de las solicitudes de un cliente por numero de identificacion.
                        _a.sent();
                        return [2 /*return*/, resObject];
                }
            });
        });
    };
    FirmlyApprovedService.prototype.isFirmlyApproved = function () {
        return !this.isEmpty() && this.getOfferType_Channel() === 'En_firme';
    };
    FirmlyApprovedService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FirmlyApprovedService_Factory() { return new FirmlyApprovedService(i0.ɵɵinject(i1.ParametersService), i0.ɵɵinject(i2.RequestService)); }, token: FirmlyApprovedService, providedIn: "root" });
    return FirmlyApprovedService;
}());
export { FirmlyApprovedService };
